export default "__VITE_ASSET__CxeVbmx4__"